import { render } from "./labProcessingFeeDialog.vue?vue&type=template&id=71149938&scoped=true"
import script from "./labProcessingFeeDialog.vue?vue&type=script&lang=js"
export * from "./labProcessingFeeDialog.vue?vue&type=script&lang=js"

import "./labProcessingFeeDialog.vue?vue&type=style&index=0&id=71149938&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71149938"]])

export default __exports__